import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'

const disableDropStyles = `
  > * {
    opacity: 0.5 !important;
  }
`

export const StyledDropLocation = styled.div((props) => {
  const { canDrop, isOver } = props

  const borderColor =
    canDrop && isOver
      ? 'sAndGDropLocationCanDropBoarderColor'
      : 'sAndGDropLocationBoarderColor'

  return `
    margin: 1px 0;
    border: 1px dotted ${themeColor(borderColor, props)};
    border-radius: 3px;

    [data-dragging] & {
      ${!canDrop ? disableDropStyles : ''}
    }
  `
})
